import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { AccountsandFinanceurl } from "../../../../config";
import { generateAndExecuteMutation, graphqlQuery } from "../../../../data/Axios/DynamicService";
import { allBanks } from "../../../../data/Axios/queries";

const base_url = AccountsandFinanceurl.uri;

const BankBranchForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  const [bankData, setBankData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchBanks() {
      try {
        const bankDataResponse = await graphqlQuery(allBanks, base_url);
        if (bankDataResponse) {
          setBankData(bankDataResponse);
        }
      } catch (error) {
        console.error("Error fetching bank data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchBanks();
  }, []);

  const bankOptions = bankData.map((bank) => ({
    value: bank.id,
    label: bank.bankName,
  }));

  const fields = [
    {
      name: "bankId",
      label: "Bank",
      type: "select",
      options: bankOptions,
      gridColumn: "span 2",
      required: true,
    },
    { name: "branchCode", label: "Branch Code", type: "text", gridColumn: "span 1", required: true },
    { name: "branchName", label: "Branch Name", type: "text", gridColumn: "span 1", required: true },
    { name: "branchSwiftCode", label: "Branch Swift Code", type: "text", gridColumn: "span 1" },
    {
      name: "useInPrintout",
      label: "Use in Printout",
      type: "checkbox",
      gridColumn: "span 1",
    },
  ];

  const initialValues = {
    id: props.data?.id || "",
    bankId: props.data?.bankId || "",
    branchCode: props.data?.branchCode || "",
    branchName: props.data?.branchName || "",
    branchSwiftCode: props.data?.branchSwiftCode || "",
    //useInPrintout: props.data?.useInPrintout || false,
    useInPrintout: props.data?.useInPrintout === 1 ? true : false,
    companyId: props.data?.companyId || companyId,
    company: props.data?.company || "",
    createdBy: props.data?.createdBy || userId,
    createdDate: props.data?.createdDate || new Date().toISOString(),
  };

  const handleSubmit = async (values, { setSubmitting }) => {
  try {
   // Convert checkbox boolean to Int
   const useInPrintoutInt = values.useInPrintout ? 1 : 0;

    const mutationData = props.isEditing
      ? {
          id: values.id,
          bankId: values.bankId,
          branchCode: values.branchCode,
          branchName: values.branchName,
          branchSwiftCode: values.branchSwiftCode,
        //useInPrintout: values.useInPrintout,
        useInPrintout: useInPrintoutInt,
          companyId: values.companyId,
          company: values.company,
        }
      : {
          bankId: values.bankId,
          branchCode: values.branchCode,
          branchName: values.branchName,
          branchSwiftCode: values.branchSwiftCode,
        // useInPrintout: values.useInPrintout,
        useInPrintout: useInPrintoutInt,
          companyId: values.companyId,
          company: values.company,
          createdBy: userId,
        };

    const response = await generateAndExecuteMutation(
      props.isEditing ? "updateBankBranch" : "createBankBranch",
      mutationData,
      props.isEditing ? "updatedBankBranch" : "newBankBranch",
      base_url
    );

    if (Object.values(response)[0] != null) {
      props.onClose();
      props.onAction();
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: `Bank branch ${props.isEditing ? "updated" : "created"} successfully.`,
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "An error occurred while processing your request. Please try again later.",
    });
  } finally {
    setSubmitting(false);
  }
};


  if (loading) return <CircularProgress />;

  return (
   <DynamicForm
  initialValues={initialValues}
  fields={fields}
 steps={[{
   stepNumber: 1,
   stepLabel: "Bank Branch Details",
   stepDescription: "Enter bank branch information",
   fields: fields.map(f => f.name),
 }]}
  onSubmit={handleSubmit}
  title={props.isEditing ? "Edit Bank Branch" : "Create Bank Branch"}
  subtitle={props.isEditing ? "Edit an Existing Bank Branch" : "Create a New Bank Branch"}
/>

  );
};

export default BankBranchForm;
